/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ExpiredSessionRouteImport } from './routes/expired-session'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as LoginSignupRouteImport } from './routes/_login-signup'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsageIndexRouteImport } from './routes/usage/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as BillingIndexRouteImport } from './routes/billing/index'
import { Route as ApplicationsIndexRouteImport } from './routes/applications/index'
import { Route as UsageWaterRouteImport } from './routes/usage/water'
import { Route as UsageElectricRouteImport } from './routes/usage/electric'
import { Route as BillingStatementsRouteImport } from './routes/billing/statements'
import { Route as BillingPaymentsRouteImport } from './routes/billing/payments'
import { Route as BillingPaymentSuccessfulRouteImport } from './routes/billing/payment-successful'
import { Route as BillingMakePaymentRouteImport } from './routes/billing/make-payment'
import { Route as BillingHistoryRouteImport } from './routes/billing/history'
import { Route as LoginSignupLoginRouteImport } from './routes/_login-signup/login'
import { Route as LoginSignupCreateUserRouteImport } from './routes/_login-signup/create-user'
import { Route as MembershipsSetupRouteRouteImport } from './routes/memberships/setup/route'
import { Route as SettingsUserProfileIndexRouteImport } from './routes/settings/user-profile/index'
import { Route as SettingsMembershipsIndexRouteImport } from './routes/settings/memberships/index'
import { Route as SettingsAuthorizedUsersIndexRouteImport } from './routes/settings/authorized-users/index'
import { Route as SettingsAccountsIndexRouteImport } from './routes/settings/accounts/index'
import { Route as MembershipsSetupIndexRouteImport } from './routes/memberships/setup/index'
import { Route as BillingPaymentMethodsIndexRouteImport } from './routes/billing/payment-methods/index'
import { Route as BillingAutomaticPaymentsIndexRouteImport } from './routes/billing/automatic-payments/index'
import { Route as UsersVerifyEmailTokenRouteImport } from './routes/users/verify-email/$token'
import { Route as UsersResetPasswordTokenRouteImport } from './routes/users/reset-password/$token'
import { Route as SettingsUserProfileUpdateSmsRouteImport } from './routes/settings/user-profile/update-sms'
import { Route as SettingsUserProfileChangePasswordRouteImport } from './routes/settings/user-profile/change-password'
import { Route as SettingsUserProfileChangeNameRouteImport } from './routes/settings/user-profile/change-name'
import { Route as SettingsUserProfileChangeEmailRouteImport } from './routes/settings/user-profile/change-email'
import { Route as SettingsMembershipsMemberNumberRouteImport } from './routes/settings/memberships/$memberNumber'
import { Route as SettingsAuthorizedUsersNewRouteImport } from './routes/settings/authorized-users/new'
import { Route as SettingsAccountsAccountNumberRouteImport } from './routes/settings/accounts/$accountNumber'
import { Route as BillingPaymentMethodsNewCheckRouteImport } from './routes/billing/payment-methods/new-check'
import { Route as BillingPaymentMethodsNewCardRouteImport } from './routes/billing/payment-methods/new-card'
import { Route as BillingAutomaticPaymentsNewRouteImport } from './routes/billing/automatic-payments/new'
import { Route as MembershipsSetupMemberNumberRouteRouteImport } from './routes/memberships/setup/$member-number/route'
import { Route as MembershipsSetupMemberNumberIndexRouteImport } from './routes/memberships/setup/$member-number/index'
import { Route as MembershipsSetupMemberNumberTapRouteImport } from './routes/memberships/setup/$member-number/tap'
import { Route as MembershipsSetupMemberNumberNotificationsRouteImport } from './routes/memberships/setup/$member-number/notifications'
import { Route as MembershipsSetupMemberNumberNewsletterRouteImport } from './routes/memberships/setup/$member-number/newsletter'
import { Route as MembershipsSetupMemberNumberGoPaperlessRouteImport } from './routes/memberships/setup/$member-number/go-paperless'
import { Route as MembershipsSetupMemberNumberCompleteRouteImport } from './routes/memberships/setup/$member-number/complete'
import { Route as MembershipsSetupMemberNumberAliasesRouteImport } from './routes/memberships/setup/$member-number/aliases'
import { Route as MembershipsSetupMemberNumberAutomaticPaymentsIndexRouteImport } from './routes/memberships/setup/$member-number/automatic-payments/index'
import { Route as MembershipsSetupMemberNumberAutomaticPaymentsSetupRouteImport } from './routes/memberships/setup/$member-number/automatic-payments/setup'

const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpiredSessionRoute = ExpiredSessionRouteImport.update({
  id: '/expired-session',
  path: '/expired-session',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyRoute = ApplyRouteImport.update({
  id: '/apply',
  path: '/apply',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSignupRoute = LoginSignupRouteImport.update({
  id: '/_login-signup',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageIndexRoute = UsageIndexRouteImport.update({
  id: '/usage/',
  path: '/usage/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingIndexRoute = BillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsIndexRoute = ApplicationsIndexRouteImport.update({
  id: '/applications/',
  path: '/applications/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageWaterRoute = UsageWaterRouteImport.update({
  id: '/usage/water',
  path: '/usage/water',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageElectricRoute = UsageElectricRouteImport.update({
  id: '/usage/electric',
  path: '/usage/electric',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingStatementsRoute = BillingStatementsRouteImport.update({
  id: '/billing/statements',
  path: '/billing/statements',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingPaymentsRoute = BillingPaymentsRouteImport.update({
  id: '/billing/payments',
  path: '/billing/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingPaymentSuccessfulRoute =
  BillingPaymentSuccessfulRouteImport.update({
    id: '/billing/payment-successful',
    path: '/billing/payment-successful',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingMakePaymentRoute = BillingMakePaymentRouteImport.update({
  id: '/billing/make-payment',
  path: '/billing/make-payment',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingHistoryRoute = BillingHistoryRouteImport.update({
  id: '/billing/history',
  path: '/billing/history',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSignupLoginRoute = LoginSignupLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => LoginSignupRoute,
} as any)
const LoginSignupCreateUserRoute = LoginSignupCreateUserRouteImport.update({
  id: '/create-user',
  path: '/create-user',
  getParentRoute: () => LoginSignupRoute,
} as any)
const MembershipsSetupRouteRoute = MembershipsSetupRouteRouteImport.update({
  id: '/memberships/setup',
  path: '/memberships/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUserProfileIndexRoute =
  SettingsUserProfileIndexRouteImport.update({
    id: '/settings/user-profile/',
    path: '/settings/user-profile/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMembershipsIndexRoute =
  SettingsMembershipsIndexRouteImport.update({
    id: '/settings/memberships/',
    path: '/settings/memberships/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAuthorizedUsersIndexRoute =
  SettingsAuthorizedUsersIndexRouteImport.update({
    id: '/settings/authorized-users/',
    path: '/settings/authorized-users/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAccountsIndexRoute = SettingsAccountsIndexRouteImport.update({
  id: '/settings/accounts/',
  path: '/settings/accounts/',
  getParentRoute: () => rootRouteImport,
} as any)
const MembershipsSetupIndexRoute = MembershipsSetupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MembershipsSetupRouteRoute,
} as any)
const BillingPaymentMethodsIndexRoute =
  BillingPaymentMethodsIndexRouteImport.update({
    id: '/billing/payment-methods/',
    path: '/billing/payment-methods/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingAutomaticPaymentsIndexRoute =
  BillingAutomaticPaymentsIndexRouteImport.update({
    id: '/billing/automatic-payments/',
    path: '/billing/automatic-payments/',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersVerifyEmailTokenRoute = UsersVerifyEmailTokenRouteImport.update({
  id: '/users/verify-email/$token',
  path: '/users/verify-email/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersResetPasswordTokenRoute = UsersResetPasswordTokenRouteImport.update({
  id: '/users/reset-password/$token',
  path: '/users/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUserProfileUpdateSmsRoute =
  SettingsUserProfileUpdateSmsRouteImport.update({
    id: '/settings/user-profile/update-sms',
    path: '/settings/user-profile/update-sms',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsUserProfileChangePasswordRoute =
  SettingsUserProfileChangePasswordRouteImport.update({
    id: '/settings/user-profile/change-password',
    path: '/settings/user-profile/change-password',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsUserProfileChangeNameRoute =
  SettingsUserProfileChangeNameRouteImport.update({
    id: '/settings/user-profile/change-name',
    path: '/settings/user-profile/change-name',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsUserProfileChangeEmailRoute =
  SettingsUserProfileChangeEmailRouteImport.update({
    id: '/settings/user-profile/change-email',
    path: '/settings/user-profile/change-email',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMembershipsMemberNumberRoute =
  SettingsMembershipsMemberNumberRouteImport.update({
    id: '/settings/memberships/$memberNumber',
    path: '/settings/memberships/$memberNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAuthorizedUsersNewRoute =
  SettingsAuthorizedUsersNewRouteImport.update({
    id: '/settings/authorized-users/new',
    path: '/settings/authorized-users/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAccountsAccountNumberRoute =
  SettingsAccountsAccountNumberRouteImport.update({
    id: '/settings/accounts/$accountNumber',
    path: '/settings/accounts/$accountNumber',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingPaymentMethodsNewCheckRoute =
  BillingPaymentMethodsNewCheckRouteImport.update({
    id: '/billing/payment-methods/new-check',
    path: '/billing/payment-methods/new-check',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingPaymentMethodsNewCardRoute =
  BillingPaymentMethodsNewCardRouteImport.update({
    id: '/billing/payment-methods/new-card',
    path: '/billing/payment-methods/new-card',
    getParentRoute: () => rootRouteImport,
  } as any)
const BillingAutomaticPaymentsNewRoute =
  BillingAutomaticPaymentsNewRouteImport.update({
    id: '/billing/automatic-payments/new',
    path: '/billing/automatic-payments/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const MembershipsSetupMemberNumberRouteRoute =
  MembershipsSetupMemberNumberRouteRouteImport.update({
    id: '/$member-number',
    path: '/$member-number',
    getParentRoute: () => MembershipsSetupRouteRoute,
  } as any)
const MembershipsSetupMemberNumberIndexRoute =
  MembershipsSetupMemberNumberIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberTapRoute =
  MembershipsSetupMemberNumberTapRouteImport.update({
    id: '/tap',
    path: '/tap',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberNotificationsRoute =
  MembershipsSetupMemberNumberNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberNewsletterRoute =
  MembershipsSetupMemberNumberNewsletterRouteImport.update({
    id: '/newsletter',
    path: '/newsletter',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberGoPaperlessRoute =
  MembershipsSetupMemberNumberGoPaperlessRouteImport.update({
    id: '/go-paperless',
    path: '/go-paperless',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberCompleteRoute =
  MembershipsSetupMemberNumberCompleteRouteImport.update({
    id: '/complete',
    path: '/complete',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberAliasesRoute =
  MembershipsSetupMemberNumberAliasesRouteImport.update({
    id: '/aliases',
    path: '/aliases',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute =
  MembershipsSetupMemberNumberAutomaticPaymentsIndexRouteImport.update({
    id: '/automatic-payments/',
    path: '/automatic-payments/',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)
const MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute =
  MembershipsSetupMemberNumberAutomaticPaymentsSetupRouteImport.update({
    id: '/automatic-payments/setup',
    path: '/automatic-payments/setup',
    getParentRoute: () => MembershipsSetupMemberNumberRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/apply': typeof ApplyRoute
  '/expired-session': typeof ExpiredSessionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/notifications': typeof NotificationsRoute
  '/memberships/setup': typeof MembershipsSetupRouteRouteWithChildren
  '/create-user': typeof LoginSignupCreateUserRoute
  '/login': typeof LoginSignupLoginRoute
  '/billing/history': typeof BillingHistoryRoute
  '/billing/make-payment': typeof BillingMakePaymentRoute
  '/billing/payment-successful': typeof BillingPaymentSuccessfulRoute
  '/billing/payments': typeof BillingPaymentsRoute
  '/billing/statements': typeof BillingStatementsRoute
  '/usage/electric': typeof UsageElectricRoute
  '/usage/water': typeof UsageWaterRoute
  '/applications': typeof ApplicationsIndexRoute
  '/billing': typeof BillingIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/usage': typeof UsageIndexRoute
  '/memberships/setup/$member-number': typeof MembershipsSetupMemberNumberRouteRouteWithChildren
  '/billing/automatic-payments/new': typeof BillingAutomaticPaymentsNewRoute
  '/billing/payment-methods/new-card': typeof BillingPaymentMethodsNewCardRoute
  '/billing/payment-methods/new-check': typeof BillingPaymentMethodsNewCheckRoute
  '/settings/accounts/$accountNumber': typeof SettingsAccountsAccountNumberRoute
  '/settings/authorized-users/new': typeof SettingsAuthorizedUsersNewRoute
  '/settings/memberships/$memberNumber': typeof SettingsMembershipsMemberNumberRoute
  '/settings/user-profile/change-email': typeof SettingsUserProfileChangeEmailRoute
  '/settings/user-profile/change-name': typeof SettingsUserProfileChangeNameRoute
  '/settings/user-profile/change-password': typeof SettingsUserProfileChangePasswordRoute
  '/settings/user-profile/update-sms': typeof SettingsUserProfileUpdateSmsRoute
  '/users/reset-password/$token': typeof UsersResetPasswordTokenRoute
  '/users/verify-email/$token': typeof UsersVerifyEmailTokenRoute
  '/billing/automatic-payments': typeof BillingAutomaticPaymentsIndexRoute
  '/billing/payment-methods': typeof BillingPaymentMethodsIndexRoute
  '/memberships/setup/': typeof MembershipsSetupIndexRoute
  '/settings/accounts': typeof SettingsAccountsIndexRoute
  '/settings/authorized-users': typeof SettingsAuthorizedUsersIndexRoute
  '/settings/memberships': typeof SettingsMembershipsIndexRoute
  '/settings/user-profile': typeof SettingsUserProfileIndexRoute
  '/memberships/setup/$member-number/aliases': typeof MembershipsSetupMemberNumberAliasesRoute
  '/memberships/setup/$member-number/complete': typeof MembershipsSetupMemberNumberCompleteRoute
  '/memberships/setup/$member-number/go-paperless': typeof MembershipsSetupMemberNumberGoPaperlessRoute
  '/memberships/setup/$member-number/newsletter': typeof MembershipsSetupMemberNumberNewsletterRoute
  '/memberships/setup/$member-number/notifications': typeof MembershipsSetupMemberNumberNotificationsRoute
  '/memberships/setup/$member-number/tap': typeof MembershipsSetupMemberNumberTapRoute
  '/memberships/setup/$member-number/': typeof MembershipsSetupMemberNumberIndexRoute
  '/memberships/setup/$member-number/automatic-payments/setup': typeof MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute
  '/memberships/setup/$member-number/automatic-payments': typeof MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/apply': typeof ApplyRoute
  '/expired-session': typeof ExpiredSessionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/notifications': typeof NotificationsRoute
  '/create-user': typeof LoginSignupCreateUserRoute
  '/login': typeof LoginSignupLoginRoute
  '/billing/history': typeof BillingHistoryRoute
  '/billing/make-payment': typeof BillingMakePaymentRoute
  '/billing/payment-successful': typeof BillingPaymentSuccessfulRoute
  '/billing/payments': typeof BillingPaymentsRoute
  '/billing/statements': typeof BillingStatementsRoute
  '/usage/electric': typeof UsageElectricRoute
  '/usage/water': typeof UsageWaterRoute
  '/applications': typeof ApplicationsIndexRoute
  '/billing': typeof BillingIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/usage': typeof UsageIndexRoute
  '/billing/automatic-payments/new': typeof BillingAutomaticPaymentsNewRoute
  '/billing/payment-methods/new-card': typeof BillingPaymentMethodsNewCardRoute
  '/billing/payment-methods/new-check': typeof BillingPaymentMethodsNewCheckRoute
  '/settings/accounts/$accountNumber': typeof SettingsAccountsAccountNumberRoute
  '/settings/authorized-users/new': typeof SettingsAuthorizedUsersNewRoute
  '/settings/memberships/$memberNumber': typeof SettingsMembershipsMemberNumberRoute
  '/settings/user-profile/change-email': typeof SettingsUserProfileChangeEmailRoute
  '/settings/user-profile/change-name': typeof SettingsUserProfileChangeNameRoute
  '/settings/user-profile/change-password': typeof SettingsUserProfileChangePasswordRoute
  '/settings/user-profile/update-sms': typeof SettingsUserProfileUpdateSmsRoute
  '/users/reset-password/$token': typeof UsersResetPasswordTokenRoute
  '/users/verify-email/$token': typeof UsersVerifyEmailTokenRoute
  '/billing/automatic-payments': typeof BillingAutomaticPaymentsIndexRoute
  '/billing/payment-methods': typeof BillingPaymentMethodsIndexRoute
  '/memberships/setup': typeof MembershipsSetupIndexRoute
  '/settings/accounts': typeof SettingsAccountsIndexRoute
  '/settings/authorized-users': typeof SettingsAuthorizedUsersIndexRoute
  '/settings/memberships': typeof SettingsMembershipsIndexRoute
  '/settings/user-profile': typeof SettingsUserProfileIndexRoute
  '/memberships/setup/$member-number/aliases': typeof MembershipsSetupMemberNumberAliasesRoute
  '/memberships/setup/$member-number/complete': typeof MembershipsSetupMemberNumberCompleteRoute
  '/memberships/setup/$member-number/go-paperless': typeof MembershipsSetupMemberNumberGoPaperlessRoute
  '/memberships/setup/$member-number/newsletter': typeof MembershipsSetupMemberNumberNewsletterRoute
  '/memberships/setup/$member-number/notifications': typeof MembershipsSetupMemberNumberNotificationsRoute
  '/memberships/setup/$member-number/tap': typeof MembershipsSetupMemberNumberTapRoute
  '/memberships/setup/$member-number': typeof MembershipsSetupMemberNumberIndexRoute
  '/memberships/setup/$member-number/automatic-payments/setup': typeof MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute
  '/memberships/setup/$member-number/automatic-payments': typeof MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_login-signup': typeof LoginSignupRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/apply': typeof ApplyRoute
  '/expired-session': typeof ExpiredSessionRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/impersonate': typeof ImpersonateRoute
  '/notifications': typeof NotificationsRoute
  '/memberships/setup': typeof MembershipsSetupRouteRouteWithChildren
  '/_login-signup/create-user': typeof LoginSignupCreateUserRoute
  '/_login-signup/login': typeof LoginSignupLoginRoute
  '/billing/history': typeof BillingHistoryRoute
  '/billing/make-payment': typeof BillingMakePaymentRoute
  '/billing/payment-successful': typeof BillingPaymentSuccessfulRoute
  '/billing/payments': typeof BillingPaymentsRoute
  '/billing/statements': typeof BillingStatementsRoute
  '/usage/electric': typeof UsageElectricRoute
  '/usage/water': typeof UsageWaterRoute
  '/applications/': typeof ApplicationsIndexRoute
  '/billing/': typeof BillingIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/usage/': typeof UsageIndexRoute
  '/memberships/setup/$member-number': typeof MembershipsSetupMemberNumberRouteRouteWithChildren
  '/billing/automatic-payments/new': typeof BillingAutomaticPaymentsNewRoute
  '/billing/payment-methods/new-card': typeof BillingPaymentMethodsNewCardRoute
  '/billing/payment-methods/new-check': typeof BillingPaymentMethodsNewCheckRoute
  '/settings/accounts/$accountNumber': typeof SettingsAccountsAccountNumberRoute
  '/settings/authorized-users/new': typeof SettingsAuthorizedUsersNewRoute
  '/settings/memberships/$memberNumber': typeof SettingsMembershipsMemberNumberRoute
  '/settings/user-profile/change-email': typeof SettingsUserProfileChangeEmailRoute
  '/settings/user-profile/change-name': typeof SettingsUserProfileChangeNameRoute
  '/settings/user-profile/change-password': typeof SettingsUserProfileChangePasswordRoute
  '/settings/user-profile/update-sms': typeof SettingsUserProfileUpdateSmsRoute
  '/users/reset-password/$token': typeof UsersResetPasswordTokenRoute
  '/users/verify-email/$token': typeof UsersVerifyEmailTokenRoute
  '/billing/automatic-payments/': typeof BillingAutomaticPaymentsIndexRoute
  '/billing/payment-methods/': typeof BillingPaymentMethodsIndexRoute
  '/memberships/setup/': typeof MembershipsSetupIndexRoute
  '/settings/accounts/': typeof SettingsAccountsIndexRoute
  '/settings/authorized-users/': typeof SettingsAuthorizedUsersIndexRoute
  '/settings/memberships/': typeof SettingsMembershipsIndexRoute
  '/settings/user-profile/': typeof SettingsUserProfileIndexRoute
  '/memberships/setup/$member-number/aliases': typeof MembershipsSetupMemberNumberAliasesRoute
  '/memberships/setup/$member-number/complete': typeof MembershipsSetupMemberNumberCompleteRoute
  '/memberships/setup/$member-number/go-paperless': typeof MembershipsSetupMemberNumberGoPaperlessRoute
  '/memberships/setup/$member-number/newsletter': typeof MembershipsSetupMemberNumberNewsletterRoute
  '/memberships/setup/$member-number/notifications': typeof MembershipsSetupMemberNumberNotificationsRoute
  '/memberships/setup/$member-number/tap': typeof MembershipsSetupMemberNumberTapRoute
  '/memberships/setup/$member-number/': typeof MembershipsSetupMemberNumberIndexRoute
  '/memberships/setup/$member-number/automatic-payments/setup': typeof MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute
  '/memberships/setup/$member-number/automatic-payments/': typeof MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/apply'
    | '/expired-session'
    | '/forgot-password'
    | '/impersonate'
    | '/notifications'
    | '/memberships/setup'
    | '/create-user'
    | '/login'
    | '/billing/history'
    | '/billing/make-payment'
    | '/billing/payment-successful'
    | '/billing/payments'
    | '/billing/statements'
    | '/usage/electric'
    | '/usage/water'
    | '/applications'
    | '/billing'
    | '/settings'
    | '/usage'
    | '/memberships/setup/$member-number'
    | '/billing/automatic-payments/new'
    | '/billing/payment-methods/new-card'
    | '/billing/payment-methods/new-check'
    | '/settings/accounts/$accountNumber'
    | '/settings/authorized-users/new'
    | '/settings/memberships/$memberNumber'
    | '/settings/user-profile/change-email'
    | '/settings/user-profile/change-name'
    | '/settings/user-profile/change-password'
    | '/settings/user-profile/update-sms'
    | '/users/reset-password/$token'
    | '/users/verify-email/$token'
    | '/billing/automatic-payments'
    | '/billing/payment-methods'
    | '/memberships/setup/'
    | '/settings/accounts'
    | '/settings/authorized-users'
    | '/settings/memberships'
    | '/settings/user-profile'
    | '/memberships/setup/$member-number/aliases'
    | '/memberships/setup/$member-number/complete'
    | '/memberships/setup/$member-number/go-paperless'
    | '/memberships/setup/$member-number/newsletter'
    | '/memberships/setup/$member-number/notifications'
    | '/memberships/setup/$member-number/tap'
    | '/memberships/setup/$member-number/'
    | '/memberships/setup/$member-number/automatic-payments/setup'
    | '/memberships/setup/$member-number/automatic-payments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/apply'
    | '/expired-session'
    | '/forgot-password'
    | '/impersonate'
    | '/notifications'
    | '/create-user'
    | '/login'
    | '/billing/history'
    | '/billing/make-payment'
    | '/billing/payment-successful'
    | '/billing/payments'
    | '/billing/statements'
    | '/usage/electric'
    | '/usage/water'
    | '/applications'
    | '/billing'
    | '/settings'
    | '/usage'
    | '/billing/automatic-payments/new'
    | '/billing/payment-methods/new-card'
    | '/billing/payment-methods/new-check'
    | '/settings/accounts/$accountNumber'
    | '/settings/authorized-users/new'
    | '/settings/memberships/$memberNumber'
    | '/settings/user-profile/change-email'
    | '/settings/user-profile/change-name'
    | '/settings/user-profile/change-password'
    | '/settings/user-profile/update-sms'
    | '/users/reset-password/$token'
    | '/users/verify-email/$token'
    | '/billing/automatic-payments'
    | '/billing/payment-methods'
    | '/memberships/setup'
    | '/settings/accounts'
    | '/settings/authorized-users'
    | '/settings/memberships'
    | '/settings/user-profile'
    | '/memberships/setup/$member-number/aliases'
    | '/memberships/setup/$member-number/complete'
    | '/memberships/setup/$member-number/go-paperless'
    | '/memberships/setup/$member-number/newsletter'
    | '/memberships/setup/$member-number/notifications'
    | '/memberships/setup/$member-number/tap'
    | '/memberships/setup/$member-number'
    | '/memberships/setup/$member-number/automatic-payments/setup'
    | '/memberships/setup/$member-number/automatic-payments'
  id:
    | '__root__'
    | '/'
    | '/_login-signup'
    | '/accept-invite'
    | '/apply'
    | '/expired-session'
    | '/forgot-password'
    | '/impersonate'
    | '/notifications'
    | '/memberships/setup'
    | '/_login-signup/create-user'
    | '/_login-signup/login'
    | '/billing/history'
    | '/billing/make-payment'
    | '/billing/payment-successful'
    | '/billing/payments'
    | '/billing/statements'
    | '/usage/electric'
    | '/usage/water'
    | '/applications/'
    | '/billing/'
    | '/settings/'
    | '/usage/'
    | '/memberships/setup/$member-number'
    | '/billing/automatic-payments/new'
    | '/billing/payment-methods/new-card'
    | '/billing/payment-methods/new-check'
    | '/settings/accounts/$accountNumber'
    | '/settings/authorized-users/new'
    | '/settings/memberships/$memberNumber'
    | '/settings/user-profile/change-email'
    | '/settings/user-profile/change-name'
    | '/settings/user-profile/change-password'
    | '/settings/user-profile/update-sms'
    | '/users/reset-password/$token'
    | '/users/verify-email/$token'
    | '/billing/automatic-payments/'
    | '/billing/payment-methods/'
    | '/memberships/setup/'
    | '/settings/accounts/'
    | '/settings/authorized-users/'
    | '/settings/memberships/'
    | '/settings/user-profile/'
    | '/memberships/setup/$member-number/aliases'
    | '/memberships/setup/$member-number/complete'
    | '/memberships/setup/$member-number/go-paperless'
    | '/memberships/setup/$member-number/newsletter'
    | '/memberships/setup/$member-number/notifications'
    | '/memberships/setup/$member-number/tap'
    | '/memberships/setup/$member-number/'
    | '/memberships/setup/$member-number/automatic-payments/setup'
    | '/memberships/setup/$member-number/automatic-payments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginSignupRoute: typeof LoginSignupRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ApplyRoute: typeof ApplyRoute
  ExpiredSessionRoute: typeof ExpiredSessionRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  ImpersonateRoute: typeof ImpersonateRoute
  NotificationsRoute: typeof NotificationsRoute
  MembershipsSetupRouteRoute: typeof MembershipsSetupRouteRouteWithChildren
  BillingHistoryRoute: typeof BillingHistoryRoute
  BillingMakePaymentRoute: typeof BillingMakePaymentRoute
  BillingPaymentSuccessfulRoute: typeof BillingPaymentSuccessfulRoute
  BillingPaymentsRoute: typeof BillingPaymentsRoute
  BillingStatementsRoute: typeof BillingStatementsRoute
  UsageElectricRoute: typeof UsageElectricRoute
  UsageWaterRoute: typeof UsageWaterRoute
  ApplicationsIndexRoute: typeof ApplicationsIndexRoute
  BillingIndexRoute: typeof BillingIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  UsageIndexRoute: typeof UsageIndexRoute
  BillingAutomaticPaymentsNewRoute: typeof BillingAutomaticPaymentsNewRoute
  BillingPaymentMethodsNewCardRoute: typeof BillingPaymentMethodsNewCardRoute
  BillingPaymentMethodsNewCheckRoute: typeof BillingPaymentMethodsNewCheckRoute
  SettingsAccountsAccountNumberRoute: typeof SettingsAccountsAccountNumberRoute
  SettingsAuthorizedUsersNewRoute: typeof SettingsAuthorizedUsersNewRoute
  SettingsMembershipsMemberNumberRoute: typeof SettingsMembershipsMemberNumberRoute
  SettingsUserProfileChangeEmailRoute: typeof SettingsUserProfileChangeEmailRoute
  SettingsUserProfileChangeNameRoute: typeof SettingsUserProfileChangeNameRoute
  SettingsUserProfileChangePasswordRoute: typeof SettingsUserProfileChangePasswordRoute
  SettingsUserProfileUpdateSmsRoute: typeof SettingsUserProfileUpdateSmsRoute
  UsersResetPasswordTokenRoute: typeof UsersResetPasswordTokenRoute
  UsersVerifyEmailTokenRoute: typeof UsersVerifyEmailTokenRoute
  BillingAutomaticPaymentsIndexRoute: typeof BillingAutomaticPaymentsIndexRoute
  BillingPaymentMethodsIndexRoute: typeof BillingPaymentMethodsIndexRoute
  SettingsAccountsIndexRoute: typeof SettingsAccountsIndexRoute
  SettingsAuthorizedUsersIndexRoute: typeof SettingsAuthorizedUsersIndexRoute
  SettingsMembershipsIndexRoute: typeof SettingsMembershipsIndexRoute
  SettingsUserProfileIndexRoute: typeof SettingsUserProfileIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expired-session': {
      id: '/expired-session'
      path: '/expired-session'
      fullPath: '/expired-session'
      preLoaderRoute: typeof ExpiredSessionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply': {
      id: '/apply'
      path: '/apply'
      fullPath: '/apply'
      preLoaderRoute: typeof ApplyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login-signup': {
      id: '/_login-signup'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LoginSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage/': {
      id: '/usage/'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/': {
      id: '/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/': {
      id: '/applications/'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof ApplicationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage/water': {
      id: '/usage/water'
      path: '/usage/water'
      fullPath: '/usage/water'
      preLoaderRoute: typeof UsageWaterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage/electric': {
      id: '/usage/electric'
      path: '/usage/electric'
      fullPath: '/usage/electric'
      preLoaderRoute: typeof UsageElectricRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/statements': {
      id: '/billing/statements'
      path: '/billing/statements'
      fullPath: '/billing/statements'
      preLoaderRoute: typeof BillingStatementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payments': {
      id: '/billing/payments'
      path: '/billing/payments'
      fullPath: '/billing/payments'
      preLoaderRoute: typeof BillingPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payment-successful': {
      id: '/billing/payment-successful'
      path: '/billing/payment-successful'
      fullPath: '/billing/payment-successful'
      preLoaderRoute: typeof BillingPaymentSuccessfulRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/make-payment': {
      id: '/billing/make-payment'
      path: '/billing/make-payment'
      fullPath: '/billing/make-payment'
      preLoaderRoute: typeof BillingMakePaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/history': {
      id: '/billing/history'
      path: '/billing/history'
      fullPath: '/billing/history'
      preLoaderRoute: typeof BillingHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_login-signup/login': {
      id: '/_login-signup/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginSignupLoginRouteImport
      parentRoute: typeof LoginSignupRoute
    }
    '/_login-signup/create-user': {
      id: '/_login-signup/create-user'
      path: '/create-user'
      fullPath: '/create-user'
      preLoaderRoute: typeof LoginSignupCreateUserRouteImport
      parentRoute: typeof LoginSignupRoute
    }
    '/memberships/setup': {
      id: '/memberships/setup'
      path: '/memberships/setup'
      fullPath: '/memberships/setup'
      preLoaderRoute: typeof MembershipsSetupRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/user-profile/': {
      id: '/settings/user-profile/'
      path: '/settings/user-profile'
      fullPath: '/settings/user-profile'
      preLoaderRoute: typeof SettingsUserProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/memberships/': {
      id: '/settings/memberships/'
      path: '/settings/memberships'
      fullPath: '/settings/memberships'
      preLoaderRoute: typeof SettingsMembershipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/authorized-users/': {
      id: '/settings/authorized-users/'
      path: '/settings/authorized-users'
      fullPath: '/settings/authorized-users'
      preLoaderRoute: typeof SettingsAuthorizedUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/accounts/': {
      id: '/settings/accounts/'
      path: '/settings/accounts'
      fullPath: '/settings/accounts'
      preLoaderRoute: typeof SettingsAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memberships/setup/': {
      id: '/memberships/setup/'
      path: '/'
      fullPath: '/memberships/setup/'
      preLoaderRoute: typeof MembershipsSetupIndexRouteImport
      parentRoute: typeof MembershipsSetupRouteRoute
    }
    '/billing/payment-methods/': {
      id: '/billing/payment-methods/'
      path: '/billing/payment-methods'
      fullPath: '/billing/payment-methods'
      preLoaderRoute: typeof BillingPaymentMethodsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/automatic-payments/': {
      id: '/billing/automatic-payments/'
      path: '/billing/automatic-payments'
      fullPath: '/billing/automatic-payments'
      preLoaderRoute: typeof BillingAutomaticPaymentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/verify-email/$token': {
      id: '/users/verify-email/$token'
      path: '/users/verify-email/$token'
      fullPath: '/users/verify-email/$token'
      preLoaderRoute: typeof UsersVerifyEmailTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/reset-password/$token': {
      id: '/users/reset-password/$token'
      path: '/users/reset-password/$token'
      fullPath: '/users/reset-password/$token'
      preLoaderRoute: typeof UsersResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/user-profile/update-sms': {
      id: '/settings/user-profile/update-sms'
      path: '/settings/user-profile/update-sms'
      fullPath: '/settings/user-profile/update-sms'
      preLoaderRoute: typeof SettingsUserProfileUpdateSmsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/user-profile/change-password': {
      id: '/settings/user-profile/change-password'
      path: '/settings/user-profile/change-password'
      fullPath: '/settings/user-profile/change-password'
      preLoaderRoute: typeof SettingsUserProfileChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/user-profile/change-name': {
      id: '/settings/user-profile/change-name'
      path: '/settings/user-profile/change-name'
      fullPath: '/settings/user-profile/change-name'
      preLoaderRoute: typeof SettingsUserProfileChangeNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/user-profile/change-email': {
      id: '/settings/user-profile/change-email'
      path: '/settings/user-profile/change-email'
      fullPath: '/settings/user-profile/change-email'
      preLoaderRoute: typeof SettingsUserProfileChangeEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/memberships/$memberNumber': {
      id: '/settings/memberships/$memberNumber'
      path: '/settings/memberships/$memberNumber'
      fullPath: '/settings/memberships/$memberNumber'
      preLoaderRoute: typeof SettingsMembershipsMemberNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/authorized-users/new': {
      id: '/settings/authorized-users/new'
      path: '/settings/authorized-users/new'
      fullPath: '/settings/authorized-users/new'
      preLoaderRoute: typeof SettingsAuthorizedUsersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/accounts/$accountNumber': {
      id: '/settings/accounts/$accountNumber'
      path: '/settings/accounts/$accountNumber'
      fullPath: '/settings/accounts/$accountNumber'
      preLoaderRoute: typeof SettingsAccountsAccountNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payment-methods/new-check': {
      id: '/billing/payment-methods/new-check'
      path: '/billing/payment-methods/new-check'
      fullPath: '/billing/payment-methods/new-check'
      preLoaderRoute: typeof BillingPaymentMethodsNewCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/payment-methods/new-card': {
      id: '/billing/payment-methods/new-card'
      path: '/billing/payment-methods/new-card'
      fullPath: '/billing/payment-methods/new-card'
      preLoaderRoute: typeof BillingPaymentMethodsNewCardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/automatic-payments/new': {
      id: '/billing/automatic-payments/new'
      path: '/billing/automatic-payments/new'
      fullPath: '/billing/automatic-payments/new'
      preLoaderRoute: typeof BillingAutomaticPaymentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memberships/setup/$member-number': {
      id: '/memberships/setup/$member-number'
      path: '/$member-number'
      fullPath: '/memberships/setup/$member-number'
      preLoaderRoute: typeof MembershipsSetupMemberNumberRouteRouteImport
      parentRoute: typeof MembershipsSetupRouteRoute
    }
    '/memberships/setup/$member-number/': {
      id: '/memberships/setup/$member-number/'
      path: '/'
      fullPath: '/memberships/setup/$member-number/'
      preLoaderRoute: typeof MembershipsSetupMemberNumberIndexRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/tap': {
      id: '/memberships/setup/$member-number/tap'
      path: '/tap'
      fullPath: '/memberships/setup/$member-number/tap'
      preLoaderRoute: typeof MembershipsSetupMemberNumberTapRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/notifications': {
      id: '/memberships/setup/$member-number/notifications'
      path: '/notifications'
      fullPath: '/memberships/setup/$member-number/notifications'
      preLoaderRoute: typeof MembershipsSetupMemberNumberNotificationsRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/newsletter': {
      id: '/memberships/setup/$member-number/newsletter'
      path: '/newsletter'
      fullPath: '/memberships/setup/$member-number/newsletter'
      preLoaderRoute: typeof MembershipsSetupMemberNumberNewsletterRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/go-paperless': {
      id: '/memberships/setup/$member-number/go-paperless'
      path: '/go-paperless'
      fullPath: '/memberships/setup/$member-number/go-paperless'
      preLoaderRoute: typeof MembershipsSetupMemberNumberGoPaperlessRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/complete': {
      id: '/memberships/setup/$member-number/complete'
      path: '/complete'
      fullPath: '/memberships/setup/$member-number/complete'
      preLoaderRoute: typeof MembershipsSetupMemberNumberCompleteRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/aliases': {
      id: '/memberships/setup/$member-number/aliases'
      path: '/aliases'
      fullPath: '/memberships/setup/$member-number/aliases'
      preLoaderRoute: typeof MembershipsSetupMemberNumberAliasesRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/automatic-payments/': {
      id: '/memberships/setup/$member-number/automatic-payments/'
      path: '/automatic-payments'
      fullPath: '/memberships/setup/$member-number/automatic-payments'
      preLoaderRoute: typeof MembershipsSetupMemberNumberAutomaticPaymentsIndexRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
    '/memberships/setup/$member-number/automatic-payments/setup': {
      id: '/memberships/setup/$member-number/automatic-payments/setup'
      path: '/automatic-payments/setup'
      fullPath: '/memberships/setup/$member-number/automatic-payments/setup'
      preLoaderRoute: typeof MembershipsSetupMemberNumberAutomaticPaymentsSetupRouteImport
      parentRoute: typeof MembershipsSetupMemberNumberRouteRoute
    }
  }
}

interface LoginSignupRouteChildren {
  LoginSignupCreateUserRoute: typeof LoginSignupCreateUserRoute
  LoginSignupLoginRoute: typeof LoginSignupLoginRoute
}

const LoginSignupRouteChildren: LoginSignupRouteChildren = {
  LoginSignupCreateUserRoute: LoginSignupCreateUserRoute,
  LoginSignupLoginRoute: LoginSignupLoginRoute,
}

const LoginSignupRouteWithChildren = LoginSignupRoute._addFileChildren(
  LoginSignupRouteChildren,
)

interface MembershipsSetupMemberNumberRouteRouteChildren {
  MembershipsSetupMemberNumberAliasesRoute: typeof MembershipsSetupMemberNumberAliasesRoute
  MembershipsSetupMemberNumberCompleteRoute: typeof MembershipsSetupMemberNumberCompleteRoute
  MembershipsSetupMemberNumberGoPaperlessRoute: typeof MembershipsSetupMemberNumberGoPaperlessRoute
  MembershipsSetupMemberNumberNewsletterRoute: typeof MembershipsSetupMemberNumberNewsletterRoute
  MembershipsSetupMemberNumberNotificationsRoute: typeof MembershipsSetupMemberNumberNotificationsRoute
  MembershipsSetupMemberNumberTapRoute: typeof MembershipsSetupMemberNumberTapRoute
  MembershipsSetupMemberNumberIndexRoute: typeof MembershipsSetupMemberNumberIndexRoute
  MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute: typeof MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute
  MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute: typeof MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute
}

const MembershipsSetupMemberNumberRouteRouteChildren: MembershipsSetupMemberNumberRouteRouteChildren =
  {
    MembershipsSetupMemberNumberAliasesRoute:
      MembershipsSetupMemberNumberAliasesRoute,
    MembershipsSetupMemberNumberCompleteRoute:
      MembershipsSetupMemberNumberCompleteRoute,
    MembershipsSetupMemberNumberGoPaperlessRoute:
      MembershipsSetupMemberNumberGoPaperlessRoute,
    MembershipsSetupMemberNumberNewsletterRoute:
      MembershipsSetupMemberNumberNewsletterRoute,
    MembershipsSetupMemberNumberNotificationsRoute:
      MembershipsSetupMemberNumberNotificationsRoute,
    MembershipsSetupMemberNumberTapRoute: MembershipsSetupMemberNumberTapRoute,
    MembershipsSetupMemberNumberIndexRoute:
      MembershipsSetupMemberNumberIndexRoute,
    MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute:
      MembershipsSetupMemberNumberAutomaticPaymentsSetupRoute,
    MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute:
      MembershipsSetupMemberNumberAutomaticPaymentsIndexRoute,
  }

const MembershipsSetupMemberNumberRouteRouteWithChildren =
  MembershipsSetupMemberNumberRouteRoute._addFileChildren(
    MembershipsSetupMemberNumberRouteRouteChildren,
  )

interface MembershipsSetupRouteRouteChildren {
  MembershipsSetupMemberNumberRouteRoute: typeof MembershipsSetupMemberNumberRouteRouteWithChildren
  MembershipsSetupIndexRoute: typeof MembershipsSetupIndexRoute
}

const MembershipsSetupRouteRouteChildren: MembershipsSetupRouteRouteChildren = {
  MembershipsSetupMemberNumberRouteRoute:
    MembershipsSetupMemberNumberRouteRouteWithChildren,
  MembershipsSetupIndexRoute: MembershipsSetupIndexRoute,
}

const MembershipsSetupRouteRouteWithChildren =
  MembershipsSetupRouteRoute._addFileChildren(
    MembershipsSetupRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginSignupRoute: LoginSignupRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ApplyRoute: ApplyRoute,
  ExpiredSessionRoute: ExpiredSessionRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  ImpersonateRoute: ImpersonateRoute,
  NotificationsRoute: NotificationsRoute,
  MembershipsSetupRouteRoute: MembershipsSetupRouteRouteWithChildren,
  BillingHistoryRoute: BillingHistoryRoute,
  BillingMakePaymentRoute: BillingMakePaymentRoute,
  BillingPaymentSuccessfulRoute: BillingPaymentSuccessfulRoute,
  BillingPaymentsRoute: BillingPaymentsRoute,
  BillingStatementsRoute: BillingStatementsRoute,
  UsageElectricRoute: UsageElectricRoute,
  UsageWaterRoute: UsageWaterRoute,
  ApplicationsIndexRoute: ApplicationsIndexRoute,
  BillingIndexRoute: BillingIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  UsageIndexRoute: UsageIndexRoute,
  BillingAutomaticPaymentsNewRoute: BillingAutomaticPaymentsNewRoute,
  BillingPaymentMethodsNewCardRoute: BillingPaymentMethodsNewCardRoute,
  BillingPaymentMethodsNewCheckRoute: BillingPaymentMethodsNewCheckRoute,
  SettingsAccountsAccountNumberRoute: SettingsAccountsAccountNumberRoute,
  SettingsAuthorizedUsersNewRoute: SettingsAuthorizedUsersNewRoute,
  SettingsMembershipsMemberNumberRoute: SettingsMembershipsMemberNumberRoute,
  SettingsUserProfileChangeEmailRoute: SettingsUserProfileChangeEmailRoute,
  SettingsUserProfileChangeNameRoute: SettingsUserProfileChangeNameRoute,
  SettingsUserProfileChangePasswordRoute:
    SettingsUserProfileChangePasswordRoute,
  SettingsUserProfileUpdateSmsRoute: SettingsUserProfileUpdateSmsRoute,
  UsersResetPasswordTokenRoute: UsersResetPasswordTokenRoute,
  UsersVerifyEmailTokenRoute: UsersVerifyEmailTokenRoute,
  BillingAutomaticPaymentsIndexRoute: BillingAutomaticPaymentsIndexRoute,
  BillingPaymentMethodsIndexRoute: BillingPaymentMethodsIndexRoute,
  SettingsAccountsIndexRoute: SettingsAccountsIndexRoute,
  SettingsAuthorizedUsersIndexRoute: SettingsAuthorizedUsersIndexRoute,
  SettingsMembershipsIndexRoute: SettingsMembershipsIndexRoute,
  SettingsUserProfileIndexRoute: SettingsUserProfileIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
